/*
 * @Author: ryanzhao1 <ryanzhao1@lexin>
 * @Date: 2024-01-03 14:59:06
 * @LastEditTime: 2024-01-04 19:37:23
 * @LastEditors: ryanzhao1
 * @Description: 
 * @FilePath: src\pc\views\home\pages\rule_history_list\rule_history_list.js
 * ©lexin ec-frd
 */
import M_REQUEST from '~request@1.0'
import M_URL from '~url@1.0'
import layout from '@pc/views/home/components/layout/index.vue'
import list from '@pc/views/home/components/list/index.vue'

import { dataReport } from '@pc/components/libs/util'

const G_REQUEST = new M_REQUEST({ gatewayType: 'platform' })

const G_QUERY = M_URL.getUrlParam() || {}
const BACK_PATH = '/rule_list'
const BACK_ACTIVE_KEY = 'platformAgreement'

export default {
	data() {
		return {
			ruleList: [], // 规则列表
			active: false, // 返回按钮是否激活
		}
	},

	components: {
		layout,
		list,
	},

	methods: {
		// 逻辑入口
		init() {

			this.queryRuleList()

		},

		// 查询协议列表
		queryRuleList() {
			const data = {
				templateCode: this.$route.query.templateCode || G_QUERY.templateCode || '' //当前合同编码
			}
			dataReport({
				eventPosName: 'history列表查询',
				hottag: 'HISTORY_VIEW'
			})
			G_REQUEST.ajax({
				url: '/route0014/platform/basic/agreementManageService/getHistoryList.json',
				data
			}).then(res => {

				if (+res.retcode === 0) {
					let result = res.result_rows || {}
					this.ruleList = result.list || []
					dataReport({
						eventPosName: 'history列表查询成功',
						hottag: 'HISTORY_VIEW_SUCCESS'
					}, { size: this.ruleList.length })
				} else {
					dataReport({
						eventPosName: 'history列表查询失败',
						hottag: 'HISTORY_VIEW_ERR'
					}, {
						...res, ...data
					})
				}

			}).catch(err => {
				this.$message.error(err)
				dataReport({
					eventPosName: 'history列表查询失败',
					hottag: 'HISTORY_VIEW_ERR'
				}, {
					...err, ...data
				})
			})

		},

		// 返回
		goBack() {
			// 更新导航选中标志
			this.active = true
			this.$router.push({
				path: BACK_PATH,
				query: { activeKey: BACK_ACTIVE_KEY } // 平台协议
			})
			dataReport({
				eventPosName: 'history列表返回',
				hottag: 'HISTORY_NAV_BACK'
			})
		},

		// 跳转到详情页
		linkToDetail(data) {
			dataReport({
				eventPosName: '下载按钮点击',
				hottag: 'RULE_HISTORY_DOWNLOAD'
			}, data)
			const { downloadUrl } = data || {}
			downloadUrl ? window.document.location.href = downloadUrl : ''
		}
	},

	mounted() {
		this.init()
	}
}